import React from "react";
import { Box, Typography, Paper, Grid, Button } from "@mui/material";
import CustomerLayout from "../CustomerLayout";

const ProductDocumentation = () => {
  const docs = [
    {
      title: "Customer Guide",
      text: "Learn how customers post loads, track transportation activity, manage payments, and communicate with carriers.",
      link: "/customer/getting-started-guides",
    },
    {
      title: "Platform Overview",
      text: "Review how HaggleFreight connects customers with drivers and carriers for load coordination, route management, and transportation operations.",
      link: "/customer/knowledge-base",
    },
    {
      title: "Support Process",
      text: "Understand how to request help for load activity, payments, account access, or platform issues.",
      link: "/customer/ticket-system",
    },
    {
      title: "Tracking & Load Status",
      text: "Review how to track a load, check current status, and follow transportation activity updates.",
      link: "/customer/track-package",
    },
  ];

  return (
    <CustomerLayout>
      <Box sx={{ maxWidth: 980, mx: "auto", py: { xs: 2, md: 4 } }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            letterSpacing: "-0.02em",
            mb: 1,
          }}
        >
          Documentation
        </Typography>

        <Typography
          sx={{
            color: "text.secondary",
            fontSize: "1rem",
            lineHeight: 1.6,
            mb: 4,
            maxWidth: 820,
          }}
        >
          Review HaggleFreight platform information, customer guidance, and
          driver / carrier workflow details.
        </Typography>

        <Grid container spacing={2}>
          {docs.map((doc) => (
            <Grid item xs={12} md={6} key={doc.title}>
              <Paper
                elevation={0}
                sx={{
                  height: "100%",
                  border: "1px solid #e5e7eb",
                  borderRadius: 3,
                  p: 3,
                  boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                  {doc.title}
                </Typography>

                <Typography
                  color="text.secondary"
                  sx={{ mb: 2.5, minHeight: 72, lineHeight: 1.6 }}
                >
                  {doc.text}
                </Typography>

                <Button
                  variant="outlined"
                  href={doc.link}
                  sx={{ textTransform: "none", fontWeight: 700 }}
                >
                  View
                </Button>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </CustomerLayout>
  );
};

export default ProductDocumentation;